import Reveal from '@/components/base/Reveal';
import SectionHeading from '@/components/base/SectionHeading';
import { team, communityUrl, communityName } from '@/mocks/strategix';

function initials(name: string) {
  return name
    .split(' ')
    .map((part) => part.charAt(0))
    .slice(0, 2)
    .join('');
}

export default function Team() {
  return (
    <section id="team" className="relative w-full px-5 md:px-10 py-20 md:py-28">
      <div className="max-w-6xl mx-auto">
        <SectionHeading
          label="Команда"
          title="Люди, которые ведут ваше сообщество"
          description="Небольшая команда специалистов, каждый из которых отвечает за свой участок работы. Вы всегда знаете, кто ведёт ваш проект."
        />

        <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {team.map((member, index) => (
            <Reveal key={member.name} delay={index * 80} className="h-full">
              <article className="h-full flex flex-col p-6 rounded-lg bg-background-100/70 border border-background-200/70 hover:border-primary-400/60 transition-colors">
                <div className="flex items-center justify-between gap-3">
                  <span className="w-12 h-12 flex items-center justify-center rounded-full bg-gradient-to-br from-primary-500 to-accent-500 font-heading font-semibold text-background-50 text-sm">
                    {initials(member.name)}
                  </span>
                  <span className="px-3 py-1 rounded-full bg-secondary-200/80 text-secondary-950 text-xs whitespace-nowrap">
                    {member.sphere}
                  </span>
                </div>
                <h3 className="mt-5 font-heading text-base md:text-lg text-foreground-950">{member.name}</h3>
                <p className="mt-1.5 text-sm text-primary-300">{member.role}</p>
                <p className="mt-3 text-sm text-foreground-600 leading-relaxed flex-1">{member.focus}</p>
              </article>
            </Reveal>
          ))}
        </div>

        <Reveal delay={150}>
          <div className="mt-8 flex flex-col lg:flex-row items-start lg:items-center gap-5 p-6 md:p-7 rounded-lg border border-accent-500/40 bg-accent-500/10">
            <span className="w-12 h-12 flex-none flex items-center justify-center rounded-md bg-accent-500/20 text-accent-300">
              <i className="ri-shield-user-line text-2xl"></i>
            </span>
            <div className="flex-1">
              <h3 className="font-heading text-base md:text-lg text-foreground-950">Как проверить сотрудника</h3>
              <p className="mt-2 text-sm text-foreground-700 leading-relaxed">
                Чтобы убедиться, что с вами общается именно наш специалист, напишите в личные сообщения{' '}
                {communityName}.
              </p>
            </div>
            <a
              href={communityUrl}
              target="_blank"
              rel="nofollow noopener noreferrer"
              className="w-full lg:w-auto inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-accent-500 text-background-50 text-sm font-semibold hover:bg-accent-400 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-vk-line text-base"></i>
              Перейти в сообщество
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}